import React from 'react';
import styles from './infoError.module.scss';
import classnames from 'classnames';
import { ReactComponent as AlertTriangleIcon } from 'v2/icons/alert-triangle-icon.svg';
import { ErrorStepComponentProps, StepComponent } from '../../ErrorStep';

const InfoError = ({ title, description }: ErrorStepComponentProps) => {
  const component: StepComponent = {
    body: <p>{description}</p>,
  };

  if (title) {
    component['header'] = (
      <div className={classnames(styles.header)}>
        <AlertTriangleIcon />
        <p>{title}</p>
      </div>
    );
  }

  return component;
};

export default InfoError;
